import { p as proxyCustomElement, H, c as createEvent, h, F as Fragment } from './index.js';
import { g as getValidityObject, c as checkValidity, r as reportValidity, s as setCustomValidity, a as setInputRef, b as getError, w as watchValue, d as watchError, e as watchWarning, f as renderFormField } from './p-Cg8AdZPK.js';
import { h as handleTabIndex } from './p-bL-8cS__.js';
import { d as defineCustomElement$6 } from './p-BbTg3Car.js';
import { d as defineCustomElement$5 } from './p-Dpb0Xahb.js';
import { d as defineCustomElement$4 } from './p-Da2lAZSv.js';
import { d as defineCustomElement$3 } from './p-CssqlikZ.js';
import { d as defineCustomElement$2 } from './p-CFAyJ2yW.js';
import { d as defineCustomElement$1 } from './p-ClSUnmWE.js';

const checkInputCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:inline-flex;flex:none;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;margin:0;max-width:100%;padding:0;width:fit-content}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}.inner{align-items:flex-start;display:flex;flex:1;gap:.5rem;height:100%;-webkit-user-select:none;user-select:none;width:100%}.inner,.input{cursor:pointer}.text{display:flex;flex-direction:column;justify-content:center;max-width:100%}:host([size=md]){--form-field--description-left:1.5rem}:host([size=md]) .label{align-items:center;color:var(--jw-theme-surface-text-default-color);display:inline-flex;font-family:Open Sans;font-size:.875rem;font-weight:400;gap:.5rem;letter-spacing:-.0004em;line-height:1.25rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host([size=md]) .description{font-family:Open Sans;font-size:.75rem;font-weight:400;letter-spacing:0;line-height:1rem}:host([size=md]:not([disabled]):focus) .input,:host([size=md]:not([disabled]):focus-visible) .input{outline:var(--jw-theme-effects-focus-default-outline)}:host([type=regular][size=lg]){flex:1;min-width:10rem}:host([type=regular][size=lg]) .inner{background-color:var(--jw-theme-form-field-default-bg-color);border:1px solid var(--jw-theme-form-border-regular-default-border-color);border-radius:.375rem;display:flex;gap:.75rem;padding:1rem}:host([type=regular][size=lg]) .text{gap:0;text-wrap:pretty}:host([type=regular][size=lg]) .label{color:var(--jw-theme-surface-text-default-color);font-family:Open Sans;font-size:.875rem;font-weight:600;letter-spacing:-.0004em;line-height:1.25rem}:host([type=regular][size=lg]) .description{color:var(--jw-theme-surface-text-description-color);font-family:Open Sans;font-size:.75rem;font-weight:400;letter-spacing:0;line-height:1rem}:host([type=regular][size=lg][disabled]) .inner{background-color:var(--jw-theme-form-field-disabled-bg-color)}:host([type=regular][size=lg][disabled]) .label{color:var(--jw-theme-form-field-disabled-color)}:host([type=regular][size=lg][disabled]) .description{color:var(--jw-theme-form-field-disabled-color)}:host([type=regular][size=lg]:not([disabled])[checked]) .inner,:host([type=regular][size=lg]:not([disabled])[indeterminate]) .inner{background-color:var(--jw-theme-surface-level1-active-bg-color);border-color:var(--jw-theme-form-border-regular-focus-border-color)}:host([size=lg]:not([disabled])[checked]:hover) .inner,:host([size=lg]:not([disabled])[indeterminate]:hover) .inner{border-color:var(--jw-theme-form-border-regular-focus-border-color)}:host([type=regular][size=lg]:not([disabled]):hover) .inner{border-color:var(--jw-theme-form-border-regular-hover-border-color);box-shadow:var(--jw-theme-effects-shadow-shadow-md-box-shadow)}:host([type=regular][size=lg][error-type=error]) .inner{background-color:var(--jw-theme-error-muted-message-bg-color);border-color:var(--jw-theme-form-border-error-default-border-color)}:host([type=regular][size=lg][error-type=error]:hover) .inner{border-color:var(--jw-theme-form-border-error-hover-border-color)}:host([size=lg]:not([disabled]):focus) .inner,:host([size=lg]:not([disabled]):focus-visible) .inner{outline:var(--jw-theme-effects-focus-default-outline)}:host(:focus),:host(:focus-visible){outline:none}:host([disabled]) .inner,:host([disabled]) .input{cursor:not-allowed}:host([disabled]) .label{color:var(--jw-theme-form-field-disabled-color)}.checkbox{align-items:center;border-radius:.125rem;border-style:solid;border-width:1px;display:flex;flex:none;height:1rem;justify-content:center;margin:.125rem 0;overflow:hidden;position:relative;transition:border-color .15s ease,background-color .15s ease,transform .15s ease;width:1rem}.checkbox wui-icon{display:block;height:.75rem;line-height:0;transform:scale(0);transition:transform .2s ease 50ms;width:.75rem;z-index:1}.checkbox wui-icon,.checkbox-inner{position:absolute;transform-origin:center center}.checkbox-inner{border-radius:.125rem;height:150%;transition:transform .25s ease;width:150%}:host([checked]:not([indeterminate])) .checkbox wui-icon[name=check]{transform:scale(1)}:host([indeterminate]) .checkbox wui-icon[name=minus]{transform:scale(1)}:host([checked]) .checkbox-inner,:host([indeterminate]) .checkbox-inner{transform:scale(0)}:host(:not([disabled])) .checkbox{border-color:var(--jw-theme-form-border-regular-default-border-color)}:host(:not([disabled])) .checkbox-inner{background-color:var(--jw-theme-form-field-default-bg-color)}:host(:not([disabled])) .checkbox wui-icon{color:var(--jw-theme-system-primary-default-color)}:host(:not([disabled])) .checkbox{background-color:var(--jw-theme-system-primary-default-bg-color)}:host(:not([disabled]):hover) .checkbox{border-color:var(--jw-theme-form-border-regular-hover-border-color)}:host(:not([disabled])[checked]) .checkbox{border-color:var(--jw-theme-system-primary-default-bg-color)}:host(:not([disabled])[checked]:hover) .checkbox{border-color:var(--jw-theme-system-primary-hover-bg-color)}:host(:not([disabled])[checked]:hover) .checkbox{background-color:var(--jw-theme-system-primary-hover-bg-color)}:host(:not([disabled])[checked]:hover) .checkbox wui-icon{color:var(--jw-theme-system-primary-hover-color)}:host(:not([disabled])[indeterminate]) .checkbox{border-color:var(--jw-theme-system-primary-default-bg-color)}:host(:not([disabled])[indeterminate]) .checkbox{background-color:var(--jw-theme-system-primary-default-bg-color)}:host(:not([disabled])[indeterminate]) .checkbox wui-icon{color:var(--jw-theme-system-primary-default-color)}:host(:not([disabled])[indeterminate]:hover) .checkbox{border-color:var(--jw-theme-system-primary-hover-bg-color)}:host(:not([disabled])[indeterminate]:hover) .checkbox{background-color:var(--jw-theme-system-primary-hover-bg-color)}:host(:not([disabled])[indeterminate]:hover) .checkbox wui-icon{color:var(--jw-theme-system-primary-hover-color)}:host([disabled]) .checkbox{border-color:var(--jw-theme-form-border-regular-default-border-color)}:host([disabled]) .checkbox-inner{background-color:var(--jw-theme-form-field-disabled-bg-color)}:host([disabled]) .inner{color:var(--jw-theme-form-field-disabled-color);cursor:not-allowed}:host([disabled][checked]) .checkbox{border-color:var(--jw-theme-form-field-disabled-inverted-bg-color)}:host([disabled][checked]) .checkbox{background-color:var(--jw-theme-form-field-disabled-inverted-bg-color)}:host([disabled][checked]) .checkbox wui-icon{color:var(--jw-theme-form-field-disabled-inverted-color)}:host([disabled][indeterminate]) .checkbox{border-color:var(--jw-theme-form-field-disabled-inverted-bg-color)}:host([disabled][indeterminate]) .checkbox{background-color:var(--jw-theme-form-field-disabled-inverted-bg-color)}:host([disabled][indeterminate]) .checkbox wui-icon{color:var(--jw-theme-form-field-disabled-inverted-color)}:host([error-type=error]) .checkbox{border-color:var(--jw-theme-form-border-error-default-border-color)}:host([error-type=error][disabled]) .checkbox{border-color:var(--jw-theme-form-border-regular-focus-border-color)}:host([error-type=error]:not([disabled]):hover) .checkbox{border-color:var(--jw-theme-form-border-error-hover-border-color)}:host([error-type=error]:not([disabled]):focus) .checkbox{border-color:var(--jw-theme-form-border-regular-focus-border-color)}:host(:not([disabled]):focus){outline:none}:host(:not([disabled]):focus) .checkbox{border-color:var(--jw-theme-form-border-regular-focus-border-color)}:host(:not([disabled]):focus[checked]) .checkbox{background-color:var(--jw-theme-system-primary-default-bg-color)}:host(:not([disabled]):focus[checked]) .checkbox wui-icon{color:var(--jw-theme-system-primary-default-color)}:host(:not([disabled]):focus[indeterminate]) .checkbox{background-color:var(--jw-theme-system-primary-default-bg-color)}:host(:not([disabled]):focus[indeterminate]) .checkbox wui-icon{color:var(--jw-theme-system-primary-default-color)}.label-container{align-items:flex-start;display:flex;gap:.25rem}.label-container wui-icon{color:var(--jw-theme-form-label-color);padding:.125rem 0}";

const WuiCheckInput = /*@__PURE__*/ proxyCustomElement(class WuiCheckInput extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.validityChecked = createEvent(this, "validityChecked", 7);
        this.validityReported = createEvent(this, "validityReported", 7);
        this.required = false;
        this.validity = getValidityObject();
        this.validationMessage = '';
        this.customValidation = undefined;
        this.checkValidity = checkValidity(this);
        this.reportValidity = reportValidity(this);
        this.setCustomValidity = setCustomValidity(this);
        this.showValidity = false;
        this.setInputRef = setInputRef(this);
        this.dirty = false;
        this.getError = getError(this);
        //////// FORM FIELD END ////////
        //////// TAB FOCUSABLE START ////////
        this._tabIndex = 0;
        //////// TAB FOCUSABLE END ////////
        /**
         * Label
         */
        this.label = '';
        /**
         * Checked state
         */
        this.checked = false;
        /**
         * Indeterminate state
         *
         * Displays line icon instead of checkmark. Takes precedence over checked state.
         */
        this.indeterminate = false;
        /**
         * Disabled state
         */
        this.disabled = false;
        this.handleChange = (e) => {
            // Prevent click event from bubbling up, because we already have
            // our own click event on the Host
            e.stopPropagation();
            if (this.disabled) {
                return;
            }
            // The input element determines the behavior
            const target = this.inputElm;
            if (!target) {
                return;
            }
            this.dirty = true;
            this.checked = target.checked;
            this.indeterminate = target.indeterminate;
            this.checkValidity();
            this.elm.dispatchEvent(new window.Event('input', { bubbles: true }));
            this.elm.shadowRoot?.querySelector('.checkbox')?.animate([
                {
                    transform: 'scale(1)',
                },
                {
                    transform: 'scale(0.8)',
                },
                {
                    transform: 'scale(1)',
                },
            ], {
                iterations: 1,
                duration: 150,
                easing: 'ease',
                fill: 'forwards',
            });
        };
    }
    _handleValueChange(newValue) {
        watchValue(this, newValue);
    }
    _watchError(...args) {
        watchError(this, ...args);
    }
    _watchWarning(...args) {
        watchWarning(this, ...args);
    }
    async _handleKeyDown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            // Forward event to hidden input
            this.inputElm?.click();
            e.preventDefault();
            e.stopPropagation();
            return true;
        }
    }
    componentWillRender() {
        handleTabIndex(this);
    }
    renderInner() {
        return (h("label", { class: "inner" }, h("input", { type: "checkbox", hidden: true, checked: this.checked, indeterminate: this.indeterminate, disabled: this.disabled, onInput: this.handleChange, name: this.name, value: this.value, required: !!this.required, ref: this.setInputRef, onChange: (e) => {
                // We want to use the input event, not 'change'
                e.stopPropagation();
            } }), h("div", { class: "checkbox input input-container" }, h("div", { class: "checkbox-inner" }), h("wui-icon", { name: "check", size: null }), h("wui-icon", { name: "minus", size: null })), (this.label || typeof this.description === 'string') && (h("div", { class: "text" }, h("div", { class: "label-container" }, this.label && (h("span", { class: "label" }, this.label, this.status && (h(Fragment, null, ' ', h("wui-status", { ...this.status, type: "label" }))))), this.tooltip && (h("wui-tooltip", { label: this.tooltip }, h("wui-icon", { name: "help-filled" })))), typeof this.description === 'string' && h("div", { class: "description" }, this.description)))));
    }
    render() {
        return renderFormField(this, this.renderInner(), {
            host: {
                role: 'checkbox',
                'aria-checked': this.indeterminate ? 'mixed' : this.checked ? 'true' : 'false',
                size: typeof this.size === 'string' ? this.size : typeof this.description === 'string' ? 'lg' : 'md',
                type: 'regular',
            },
        });
    }
    get elm() { return this; }
    static get watchers() { return {
        "value": ["_handleValueChange"],
        "error": ["_watchError"],
        "warning": ["_watchWarning"]
    }; }
    static get style() { return checkInputCss; }
}, [257, "wui-check-input", {
        "value": [1537],
        "required": [8],
        "error": [8],
        "warning": [8],
        "validate": [16],
        "validity": [1040],
        "validationMessage": [1025, "validation-message"],
        "checkValidity": [16, "check-validity"],
        "reportValidity": [16, "report-validity"],
        "setCustomValidity": [16, "set-custom-validity"],
        "formField": [16, "form-field"],
        "label": [1],
        "description": [1],
        "size": [1],
        "checked": [1540],
        "indeterminate": [1540],
        "disabled": [516],
        "name": [1],
        "status": [16],
        "tooltip": [1],
        "customValidation": [32],
        "showValidity": [32]
    }, [[0, "keydown", "_handleKeyDown"]], {
        "value": ["_handleValueChange"],
        "error": ["_watchError"],
        "warning": ["_watchWarning"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-check-input", "wui-box", "wui-form-field", "wui-icon", "wui-status", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-check-input":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiCheckInput);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-status":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiCheckInput as W, defineCustomElement as d };
